module.exports = __webpack_public_path__ + "static/media/user.a1bfd435.svg";